import { render, staticRenderFns } from "./RequestedChangesViewInfo.vue?vue&type=template&id=5288c310&"
import script from "./RequestedChangesViewInfo.vue?vue&type=script&lang=js&"
export * from "./RequestedChangesViewInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports